import styled, { css } from 'styled-components'
import { space } from 'styled-system'
import { description, smallDescription } from '../Typography/Text'

export interface InputHasErrorProp {
  hasError?: boolean
}

export interface InputSizeVariantProp {
  variant?: 'regular' | 'small'
}

export const baseStyles = css<InputHasErrorProp>`
  transition: all 0.2s ease-in-out;
  background: transparent;
  ${space};
  height: 2.5rem;
  ${description};
  display: block;
  padding: 1rem 0 0.5rem;
  outline: 0;
  position: relative;
  border: none;
  border-radius: 0;
  border-bottom: 1px solid ${(p) => p.theme.colors.shades[500]};
  width: 100%;

  &:focus,
  &:not(:placeholder-shown) {
    &::placeholder {
      opacity: 1;
    }
    & + label {
      opacity: 1;
      top: 0.5rem;
    }
  }

  ${(p) =>
    p.hasError
      ? css`
          border-color: ${p.theme.rolex.colors.red};
          border-width: 2px;

          & + label {
            color: ${p.theme.rolex.colors.red};
          }
        `
      : css`
          &:hover {
            border-color: ${(p) => p.theme.colors.shades[500]};
          }
        `}

  &:disabled {
    cursor: not-allowed;
    color: ${(p) => p.theme.colors.shades[900]};
  }
`

export const Error = styled.span<{ errorOnTop: boolean }>`
  position: absolute;
  top: ${(p) => (p.errorOnTop ? '2px' : 'calc(100% + 0.25rem)')};
  ${smallDescription};
  color: ${(p) => p.theme.rolex.colors.red};
`
